import React from 'react';
import PropTypes from 'prop-types';
import { Formik } from 'formik';
import ValidatesFormWith from '../../../utils/ValidatesFormWith';
import validationSchema from './adminValidation';
import Input from '../../../components/Input';
import Textarea from '../../../components/Textarea';


class AdminForm extends React.Component {
  process = (values) => {
    const userData = {
      name: values.name,
      password: values.password,
      website: values.website,
      biography: values.biography,
    };

    this.props.onEditUser(userData);
  };

  render() {
    const {
      user,
    } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={{
          name: user.name || '',
          website: user.website || '',
          biography: user.biography || '',
        }}
        onSubmit={this.process}
        validate={ValidatesFormWith(validationSchema)}
        render={props => (
          <form onSubmit={props.handleSubmit}>
            <div className="search-contents-sidebar">
              <div className="row">
                <div className="col-md-6">
                  <Input
                    label="Nombre"
                    name="name"
                  />
                </div>
                <div className="col-md-6">
                  <Input
                    label="Sitio Web"
                    name="website"
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <Textarea
                    label="Biografía"
                    name="biography"
                  />
                </div>
              </div>
              <div className="m-b-md m-t-md">
                <button type="submit" className="book-btn">
                  <span className="book-btn-l">
                    <i className="fa fa-save" />
                  </span>
                  <span className="book-btn-r">Guardar</span>
                  <div className="clear" />
                </button>
              </div>
            </div>
          </form>
        )}
      />
    );
  }
}

AdminForm.propTypes = {
  onEditUser: PropTypes.func,
};

AdminForm.defaultProps = {
  onEditUser: () => {},
};

export default AdminForm;



// WEBPACK FOOTER //
// ./src/containers/Profile/EditProfile/AdminForm.js